exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".formula .information-unit{background-color:#98c9dd;padding:2px}", ""]);

// exports
